import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        companyUsers: '=',
        formCategories: '=',
        sites: '<'
    },
    template: `
    <div class="col00">
        <div class="heading01 type01">
            <h1>{{ 'forms.Forms' | translate }}</h1>
            <forms-forms-actions list="vm.list" filter="vm.filter" sites="vm.sites"></forms-forms-actions>
        </div>
        <forms-forms-filter sites="vm.sites" company-users="vm.companyUsers" form-categories="vm.formCategories" list="vm.list" filter="vm.filter" default-query="vm.defaultQuery"/>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="vm.list.items.length && !vm.list.loading">
            <pagination-tools list="vm.list"></pagination-tools>
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'forms.Name' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('category')"><a ng-click="vm.list.sortBy('category')">{{ 'forms.Category' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('displayName')"><a ng-click="vm.list.sortBy('displayName')">{{ 'forms.Author' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('created')"><a ng-click="vm.list.sortBy('created')">{{ 'forms.Created' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('questionCount')"><a ng-click="vm.list.sortBy('questionCount')">{{ 'forms.Questions' | translate }}</a></th>
                    <!--<th>&nbsp;</th>-->
                </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="form in vm.list.items">
                        <td><a ui-sref="authorized.forms.forms.form.general({ id: form.id })">{{ form.activeI18n.name }}</a></td>
                        <td>{{ form.category ? form.category.name : '' }}</td>
                        <td>{{ form.author ? form.author.displayName : '' }}</td>
                        <td>{{ form.createdAt * 1000 | date : 'dd.MM.yyyy' }}</td>
                        <td>{{ form.questionCount }}</td>
                        <!--<td class="actions">-->
                            <!--<a ng-click="vm.delete(form)" class="btn delete">{{ 'forms.Delete' | translate }}</a>-->
                        <!--</td>-->
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, DATATABLES, ListFactory, FormResource, ModalService) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;

        this.defaultQuery = { expand: 'formI18ns,category,author,activeI18n' };

        this.filter = lodash.assign({}, this.defaultQuery);
        this.list = ListFactory.createWithPagination(FormResource.search.bind(FormResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 25;

        this.list.fetch({}, this.filter);
    }

    delete (form) {
        return this.ModalService.delete()
            .then(() => form.$delete({ id: form.id }))
            .then(() => {
                this.toastr.success(this.$translate.instant('forms.Form deleted'));
                this.list.fetch({}, this.filter);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/list/index.js